import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
import ChapterSectionPressPlay from '../../chapter/ChapterSectionPressPlayPixi';
import ChapterSectionVideo from '../../chapter/ChapterSectionVideo';

import OpenCloseButton from '../../ui/OpenCloseButton';
import styles from './detailViewer.module.scss';

class DetailViewer extends Component {
  state = {
    isPlaylistOpen: false,
    isVideoOpen: false,
  };
  componentDidUpdate(prevProps) {
    if (prevProps.detail.title !== this.props.detail.title) {
      this.reset();
    }
  }
  setPlaylistOpen = value => {
    this.setState({
      isPlaylistOpen: value,
    });
  };
  setVideoOpen = value => {
    this.setState({
      isVideoOpen: value,
    });
  };
  reset() {
    this.setState({
      isPlaylistOpen: false,
      isVideoOpen: false,
    });
  }

  render() {
    return (
      <div className={`${styles.container} blur-in-up transition-${status}`}>
        <div className={styles.buttonWrap}>
          <OpenCloseButton
            buttonStyle={`close`}
            isActive={this.state.isPlaylistOpen}
            onClick={this.props.closeActiveDetail}
          />
        </div>
        {this.props.detail.detail_type === 'press_and_hold' ? (
          <ChapterSectionPressPlay
            {...this.props.parentProps}
            {...this.state}
            isChapter={false}
            sectionData={{ playlists: [{ ...this.props.detail }] }}
            setPlaylistOpen={this.setPlaylistOpen}
          />
        ) : (
          <ChapterSectionVideo
            sectionData={{
              ...this.props.detail,
              image: {
                sizes: {
                  large: this.props.detail.poster.sizes.medium_large,
                },
              },
            }}
            setVideoOpen={this.setVideoOpen}
            isVideoOpen={this.state.isVideoOpen}
          />
        )}
      </div>
    );
  }
}

export default DetailViewer;



// WEBPACK FOOTER //
// ./src/components/tour/details/DetailViewer.js